module.exports = __webpack_public_path__ + "img/biaoji-detail.907e422f.png";